import React from 'react';
import styles from './Hero.module.css';
import { personal, stats } from '../data/portfolio';

export default function Hero() {
  const scrollTo = (id) => document.querySelector(id)?.scrollIntoView({ behavior: 'smooth' });

  return (
    <div className="stack fade-in" style={{ marginBottom: '64px' }}>
      <div className="stack-inner">
        <div className={styles.heroInner}>
          <div>
            <div className={styles.tag}>{personal.role}</div>
            <h1 className={styles.heading}>
              {personal.name.split(' ')[0]}<br /><em>{personal.name.split(' ')[1]}</em>
            </h1>
            <p className={styles.bio}>{personal.tagline}</p>
            <div className={styles.actions}>
              <a href="#projects" className="btn btn-dark" onClick={e => { e.preventDefault(); scrollTo('#projects'); }}>
                View my work
              </a>
              <a href="#contact" className="btn btn-outline">Get in touch</a>
            </div>
          </div>
          <div className={styles.avatar}>
            <div className={styles.avatarCircle}>
              <img 
              src="/profile.jpeg" 
              alt="Mradul Kapoor" 
              className={styles.avatarImg} />
            </div>
            <div className={styles.cgpa}>
              <div className={styles.cgpaNum}>{personal.cgpa}</div>
              <div className={styles.cgpaLabel}>CGPA / 10</div>
            </div>
          </div>
        </div>
        <div className={styles.statsRow}>
          {stats.map((s) => (
            <div key={s.label} className={styles.stat}>
              <div className={styles.statNum}>{s.num}</div>
              <div className={styles.statLabel}>{s.label}</div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
